// extracted by mini-css-extract-plugin
module.exports = {"container":"YfuMw9dJ"};